<template>
    <div>
        <menu-bar/>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"><i class="fa fa-suitcase" aria-hidden="true"></i> SPLITTERS</li>
                </ol>

                <div class="row">
                    <div class="col-md-3">
                        <splitters-menu/>
                    </div>

                    <div class="col-md-9">

                        <div class="col-md-7">
                            <label for="nome" class="control-label">BUSCA POR NOME DOS SPLITTERS</label>
                            <input id="nome" type="text" v-model="nome" class="form-control">
                        </div>

                        <div class="col-md-5">
                            <br/>
                            <blockquote class="blockquote-reverse">
                                Total de Splitters: <b>{{ getContratos.length }}</b>
                            </blockquote>
                        </div>

                        <div class="col-md-12" style="margin-top: 20px">

                            <table id="mytable" class="table table-bordred table-striped">

                                <thead>
                                    <tr>
                                        <th>PORTA</th>
                                        <th style="text-align: center;width: 140px">AÇÕES</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr v-for="r in getContratos" v-bind:key="r._id">
                                        <td>{{ r.nome }}</td>
                                        <td style="text-align: center">
                                            <a :href="'#/splitter/add/' + r._id" class="btn btn-primary btn-xs">
                                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                            </a> &nbsp;
                                            <button @click="excluir(r._id)" v-if="user.level < 3" class="btn btn-danger btn-xs">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { SplittersMenu } from "../../components/exports";
import { Splitter } from "../../class/index";

export default {
    components: {
        SplittersMenu
    },
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }
            return this.contratos.filter(player => {
                return player.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    },
    methods: {
        excluir(id) {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "EXCLUIR",
                    confirmButtonText: "Excluir",
                    text: "Posso excluir a porta?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Splitter.excluir(id)
                                .then(() => {
                                    this.load();
                                    resolve();
                                })
                                .catch(err => {
                                    console.error(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        load() {
            Splitter.all()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        }
    }
};
</script>
